import { Pipe, PipeTransform } from '@angular/core';

import { TelService } from '../tel.service';

@Pipe({ name: 'trTel' })
export class TelPipe implements PipeTransform {
  constructor(
    private readonly telService: TelService,
  ) {
  }

  transform(phone: string, countryAbbr?: string, format?: string): any {
    return this.telService.format(phone, countryAbbr, format);
  }
}
